<template>

<app-page>

	<app-page-head noun="location" title="Locations" :count="list.length">

		<app-page-head-search v-model="searchText" :count="list.length" />

		<app-page-head-action v-on:click="onExportClick" :loading="is.exporting" icon="download" tooltip="Export locations" />

		<template v-if="$permission('full')">

			<app-page-head-action route="Location.Clone" icon="clone" tooltip="Clone location" />
			<app-page-head-action route="Location" :params="{ location: 'new' }" icon="create" tooltip="Add location" />
			<app-page-head-action v-if="$canDelete" v-on:click="onDeleteClick" :danger="true" :disabled="!selected.length" :count="selected.length" icon="delete" tooltip="Delete selected item(s)" />

		</template>

	</app-page-head>

	<app-page-content :is-empty="!list.length" empty-message="No locations found.">

		<com-item v-for="item in list" :key="item.id" :item="item" :highlight="searchText" :selected="isSelected(item.id)" v-on:shiftclick="onSelectClick(item.id)" />

	</app-page-content>

	<app-page-foot />

</app-page>

</template>

<script>

import axios from 'axios'
import mixList from '@/mixin/list'

export default {

	mixins: [mixList],

	components: {
		'com-item': () => import('./locations/Item')
	},

	data: function() {

		return {
			store: 'locations',
			is: {
				exporting: false
			}
		}

	},

	methods: {

		search: function(value) {

			return this.$util.search(value.title, this.searchText)

		},

		onExportClick: function() {

			this.is.exporting = true

			axios.get(this.$api.api + 'locations/export.json', {
				responseType: 'blob'
			}).then(function(response) {

				var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
				var url = URL.createObjectURL(blob)
				var link = document.createElement('a')
				link.href = url
				link.download = 'content-export.xlsx'
				link.click()
				URL.revokeObjectURL(url)

				this.is.exporting = false

			}.bind(this), function() {

				this.is.exporting = false

			}.bind(this))

		}

	}

}

</script>

<style scoped>

</style>
